export default __webpack_public_path__ + "static/media/ic_stop.91b1c838.svg";